var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadSelect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 76,
    viewBox: "0 0 72 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63 53.5V67H9V53.5H0V67C0 71.95 4.05 76 9 76H63C67.95 76 72 71.95 72 67V53.5H63Z",
    fill: "#AFAFAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.845 28.845L13.5 22.5L36 0L58.5 22.5L52.155 28.845L40.5 17.235V54H31.5V17.235L19.845 28.845Z",
    fill: "#1FAEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSelect);
export default __webpack_public_path__ + "static/media/upload_select.85d50317e140862d2d1b65759e3c8e95.svg";
export { ForwardRef as ReactComponent };